import React from 'react';

const PageWrapper = ({ fluid = false, children }) => {
  return (
    <div className={fluid ? 'container-fluid' : 'container'}>
      <div className="row pt-4 bg-default">{children}</div>
    </div>
  );
};

export default PageWrapper;



// WEBPACK FOOTER //
// src/modules/common/components/PageWrapper.js